import React from 'react'
import "./About.css";
import Counter from '../componnents/counter/Counter';
// import Counter2 from '../componnents/c2/Counter2';
import Our from "../componnents/our/Our";
import ContactButton from '../componnents/contactbutton/ContactButton';
import Obp from '../componnents/obp/Obp';


const About = () => {
  return (
    <>
    <div>
    <div>
        {/* <Carousels /> */}
        <div className="section2">
          <div className="container">
            <div className="content-section">
              <div className="title">
                <h1>About Somnath polytex</h1>
                <div className="image-section2">
              <img src="/images/hero1.jpg" alt="" />
              </div>
              </div>
              {/* <div className="content">
                <h3>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Excepturi quasi odio, numquam fugiat illum similique!</h3>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt inventore vitae doloremque dolore ut iusto recusandae beatae esse mollitia voluptate optio atque totam autem non blanditiis, odit commodi ullam repellat.</p>
               
              </div> */}
              {/* <div className="image-section2">
              <img src="/images/6.jpg" alt="" />
            </div> */}
              <div className="social">
                {/* <a href=""><i className='fab fa-facebook-f'></i></a>
                <a href=""><i className='fab FaTwitter'></i></a>
                <a href=""><i className='fab fa-instagram'></i></a> */}
              </div>
            </div>
            <div className="image-section">
              <img src="/images/45.jpg" alt="" />
              {/* <div className="content-section"> */}
              <div className="content">
                {/* <h3>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Excepturi quasi odio, numquam fugiat illum similique!</h3> */}
                <p>Somnath Polytex, a manufacturing company specializing in products such as PP woven fabric, PP woven sack bags.</p>
               
              {/* </div> */}
              </div>
            </div>
           <hr size = "7" />



<br></br>


           <div className="content-section">
              <div className="title">
                <h3>Welcome To Somnath polytex </h3>
                </div>
                <div className="content">
                {/* <h3>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Excepturi quasi odio, numquam fugiat illum similique!</h3> */}
                <p>At Somnath Polytex, we take pride in our commitment to delivering high-quality, innovative, and sustainable solutions in the world of packaging materials. With a strong focus on environmental responsibility and customer satisfaction, we have established ourselves as a trusted global provider of PP woven fabric, and PP woven sack bags, .</p>
                {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt inventore vitae doloremque dolore ut iusto recusandae beatae esse mollitia voluptate optio atque totam autem non blanditiis, odit commodi ullam repellat.</p> */}
               
              {/* </div> */}
              
              </div>
              {/* <div className="content">
                <h3>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Excepturi quasi odio, numquam fugiat illum similique!</h3>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt inventore vitae doloremque dolore ut iusto recusandae beatae esse mollitia voluptate optio atque totam autem non blanditiis, odit commodi ullam repellat.</p>
               
              </div> */}
              {/* <div className="image-section2">
              <img src="/images/6.jpg" alt="" />
            </div> */}
              <div className="social">
                {/* <a href=""><i className='fab fa-facebook-f'></i></a>
                <a href=""><i className='fab FaTwitter'></i></a>
                <a href=""><i className='fab fa-instagram'></i></a> */}
              </div>
            </div>
            <div className="image-section">
              {/* <img src="/images/hero1.jpg" alt="" /> */}
              {/* <div className="content-section"> */}
              <div className="content">
                {/* <h3>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Excepturi quasi odio, numquam fugiat illum similique!</h3> */}
                <p>Somnath Polytex was founded with a vision to revolutionize the packaging industry by providing superior products that meet the diverse needs of our customers. With a legacy dating back over [5 years], we have evolved and adapted to the changing landscape of the global market.</p>
                <p>At Somnath Polytex, we understand the responsibility that comes with manufacturing and supplying packaging materials. We are committed to reducing waste, conserving resources, and adopting eco-friendly practices. Our sustainability initiatives include optimizing packaging designs, promoting reusable and recyclable materials, and minimizing our carbon footprint.</p>
               
              {/* </div> */}
              </div>
            </div>

            
          </div>
        </div>
       
    </div>
   
   
   
   </div>

   <div>
   
   
   </div>
  

<Counter />
<Our />
<ContactButton />
<Obp />


{/* <Counter2 /> */}

   </>

  )
}

export default About
